import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../../apimethods/api-method';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import { Issues_ListModel } from './issue-list-model';
declare var $;

@Component({
  selector: 'app-issue-list',
  templateUrl: './issue-list.component.html',
  styleUrls: ['./issue-list.component.css']
})
/** IssueList component*/
export class IssueListComponent implements OnInit {
  modelItem = new Issues_ListModel();

  @ViewChild('dataTable', { static: false }) table: { nativeElement: any; }
  dataSet: string;
  dataTable: any;
  aissuelist: any;
  PublicationApproved: any;
  IssueMakeUp: any;
  OnlinePublication: any;
  CopyDueDate: string;
  title: string;

  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }
  /** IssueList ctor */
  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <Issues_ListModel>data["issueListPage"];

        this.GetissueData();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      }
    );
  }


  GetissueData() {

    $("#LoadingImage").show();
    localStorage.aEID = null;
    var issueDataParam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      ModuleName: "issueList_Module"
    }

    ApiMethod.postMethod(this.modelItem.IssuelistAPI, issueDataParam).subscribe(
      Response => {

        this.dataSet = JSON.stringify(Response.aDataitem); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = Response.aColList; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'issueList_Module';
        dataItem.infoPopupID = 'ID';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
  issuelistbyid() {
    $("#LoadingImageReopen").show();
    this.cleardata();

    $("#btnPopupartDetails").show();
    $('.tblissueList').css('height', (GlobalConstants.size.height - 200));

    ApiMethod.getMethod(this.modelItem.getissuelistbyIdAPI + "/" + localStorage.aEID).subscribe(
      Response => {
        var aissuelist = Response.aDataitemByid;
        this.title = "Issue Details";

        if (aissuelist.length > 0) {
          this.PublicationApproved = GlobalConstants.FormatDate(aissuelist[0].PublicationApproved);
          this.IssueMakeUp = GlobalConstants.FormatDate(aissuelist[0].IssueMakeUp);
          this.OnlinePublication = GlobalConstants.FormatDate(aissuelist[0].OnlinePublication);
          this.CopyDueDate = GlobalConstants.FormatDate(aissuelist[0].CopyDueDate);
        }

        $("#tblissueList tbody").html("");

        var nRowL = "";
        for (var i = 0; i < aissuelist.length; i++) {
          nRowL += "<tr id='trCnt_" + (i + 1).toString() + "'>";
          nRowL += "<td>" + (i + 1).toString() + "</td>";
          nRowL += "<td>" + aissuelist[i].Acronym + "</td>";
          nRowL += "<td>" + aissuelist[i].ArticleNo + "</td>";
          nRowL += "<td>" + aissuelist[i].Manuscript + "</td>";
          nRowL += "<td>" + aissuelist[i].ArticleTitle + "</td>";
          nRowL += "<td>" + aissuelist[i].ArticleType + "</td>";
          nRowL += "<td>" + GlobalConstants.isNullCheck(aissuelist[i].Authors) + "</td>";
          nRowL += "<td>" + GlobalConstants.isNullCheck(aissuelist[i].AuthorEMail) + "</td>";
          nRowL += "<td>" + aissuelist[i].MSPage + "</td>";
          nRowL += "</tr>";
        }

        $("#tblissueList tbody").append(nRowL); 
        $("#LoadingImageReopen").hide();
      }, error => {
        $("#LoadingImageReopen").hide();
        ngswal("Failed !", error.message, "error");
      }
    );

  }

  hide() {
    $("#btnPopupartDetails").hide();
  }
  cleardata() {
    $("#tblissueList tbody").html("");
    this.PublicationApproved = "";
    this.IssueMakeUp = "";
    this.OnlinePublication = "";
    this.CopyDueDate = "";
  }

}
